import style from './style.scss';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

class VideoPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      basePath: props.basePath,
      videoURL: props.videoURL
    };
  }

  componentDidMount() {
    if (!window.matchMedia('(max-width: 900px)').matches) {
      // this.closeModal();
      document.getElementById('videoEle').style.objectFit = 'cover';
      document.getElementById('videoEle').style.height = '100vH';
    }
  }

  closeModal = () => {
    document.body.classList.remove('open_modal');
    document
      .getElementById('user_modal')
      .removeChild(document.getElementById('modal_content_video'));
  };

  render() {
    return (
      <div class='videoWrapperVideoPopup'>
        <button
          type='button'
          class='swal2-close close-button-class custom_close'
          aria-label='Close this dialog'
          style='top: 4% !important;position:fixed;'
          onClick={this.closeModal}
        >
          ×
        </button>
        {/* object-fit: cover */}
        <video
          id='videoEle'
          style='width: 100vW;margin: 0vw;'
          autoplay
          loop='true'
          playsinline
          controls
        >
          <source
            src={this.state.basePath + this.state.videoURL}
            type='video/mp4'
          />
        </video>
      </div>
    );
  }
}

export default VideoPopup;



// WEBPACK FOOTER //
// ./components/popupContents/videoPopup.js